import { z } from 'zod';

/** URL search for attendance-core mock target selection (Dexie-backed). */
export const attendancePersonTargetsSearchSchema = z.object({
  page: z.coerce.number().optional().default(1),
  pageSize: z.coerce.number().optional().default(100),
  freeText: z.string().optional(),
  departmentIn: z.array(z.string()).optional()
});
export type AttendancePersonTargetsSearch = z.infer<typeof attendancePersonTargetsSearchSchema>;